import React, { useEffect, useState, SyntheticEvent } from 'react'
import { useWindowDimensions } from '../../../utils'
import './styles/index.css'; // these styles probably need to move elsewhere
//import { EventCreationDetails, EventSeriesProps } from './types/eventModel' // TODO: these should be consolidated into models/event/[somehwere]
//import { EventInfo } from '../../../models/event/eventModel'
import { ClickableCalendar } from './components/ClickableCalendar'
import { EventFormModal } from './components/EventFormModal'
import moment from 'moment'
import jstz from 'jstimezonedetect'

interface EventCalendarProps {
  loggedInUser?: number,
  authToken?: string
}

export const EventCalendar:React.FC<EventCalendarProps> = (props: EventCalendarProps)=>{
  const { windowHeight, windowWidth } = useWindowDimensions()
  const [createEventDialogOpen, setCreateEventDialogOpen] = useState(false)
  const [userCanCreate, setUserCanCreate] = useState(false);





  //TODO: Make this local time
  var tz = jstz.determine();
  const timeZone = tz.name();
  moment.tz.setDefault('America/New_York');



  
  const handleRSVPToggle =(eid:number)=> {
    const requestOptions = {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${props.authToken}` }
    }
    
    return fetch(process.env.REACT_APP_REFLEBULA + `/a1/tga/events/${eid}/rsvp`, requestOptions)
    .then(res => res.json())
    .then((res) => {
      if (res.result && res.result === `success`) {
          setCreateEventDialogOpen(false)
          //TODO: Tell Calendar Component to Rerender (?)
          return true;
      } else {
          console.error(`Backend Error in handleRSVPToggle`);
          res.reason && console.error(`Reason: ${res.reason}`);
          res.exception && console.error(`Exception: ${res.exception}`);
          return false;
      }
    })
    .catch((reason) => {
        console.error('Fetch Exception in handleRSVPToggle')
        console.error(`Reason: ${reason}`)
        return false;
    })
  }





  const handleOnSuccessfulSubmission = () =>
  {
    setCreateEventDialogOpen(false)
    //TODO: Tell Calendar Component to Re-render.
  }




  React.useEffect(() => {
    const requestOptions = {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${props.authToken}` }
    }

    if(props.loggedInUser && props.authToken) {

      fetch(process.env.REACT_APP_REFLEBULA + `/a1/tga/events/canCreate`, requestOptions)
        .then((res) => res.json())
        .then((res) => {
          if(res.result && res.result === `success`) {
              setUserCanCreate(res.value);
          } else {
            console.error(`Backend Error in canCreate`);
            res.reason && console.error(`Reason: ${res.reason}`);
            setUserCanCreate(false);
          }
        })
    } else {
      setUserCanCreate(false);
    }
  },[props.loggedInUser, props.authToken])

  return (
    <div style={{height:windowHeight-375, display:'flex', flexDirection:'column', alignItems:'center'}}>
      <ClickableCalendar />
      {userCanCreate &&<div 
          id='create-event-button' 
          onClick={()=>setCreateEventDialogOpen(true)}
      >
          Create New Event
      </div>}
      <dialog style={{zIndex:20, height:'75%', position:'absolute', top:100, width:'60%'}} open={createEventDialogOpen}>
        <EventFormModal 
          onCancel={()=>setCreateEventDialogOpen(false)}
          loggedInUser={props.loggedInUser} 
          authToken={props.authToken} 
          onSubmitSuccessful={handleOnSuccessfulSubmission}
          onRSVPToggle={handleRSVPToggle}
          readonly={false}
        />
      </dialog>
    </div>
  )
}

export default EventCalendar
